// Vitals subsection questionnaire constants
export enum VitalsQuestionnaireItem {
  MEDICAL_BACKGROUND_VITALS = 'medical-background/vitals',
  MEDICAL_BACKGROUND_VITALS_TEMPERATURE = 'medical-background/vitals/temperature',
  MEDICAL_BACKGROUND_VITALS_PULSE = 'medical-background/vitals/pulse',
  MEDICAL_BACKGROUND_VITALS_RESPIRATIONS = 'medical-background/vitals/respirations',
  MEDICAL_BACKGROUND_VITALS_O2_SATURATION = 'medical-background/vitals/o2-saturation',
  MEDICAL_BACKGROUND_VITALS_BLOOD_PRESSURE = 'medical-background/vitals/blood-pressure',
  MEDICAL_BACKGROUND_VITALS_HEIGHT = 'medical-background/vitals/height',
  MEDICAL_BACKGROUND_VITALS_BLOOD_SUGAR = 'medical-background/vitals/blood-sugar',
  MEDICAL_BACKGROUND_VITALS_WEIGHT = 'medical-background/vitals/weight'
}
